import PropTypes from 'prop-types';
import { notification, Popover } from 'antd';
import useBreakpoint, { BREAKPOINTS_SIZES } from '../../hooks/useBreakpoint';

import './index.less';

export default function Tooltip({ title, description, children }) {
  const breakpoint = useBreakpoint();
  if ([BREAKPOINTS_SIZES.MOBILE, BREAKPOINTS_SIZES.TABLET].includes(breakpoint)) {
    const onMobileClick = () => {
      notification.open({
        duration: 0,
        message: <span className="tooltip__title">{title}</span>,
        description: <span className="tooltip__description">{description}</span>,
        placement: 'bottomRight',
        className: 'tooltip__notification',
        key: 'updatable',
      });
    };

    return (
      <div className="tooltip" onClick={onMobileClick}>
        {children}
      </div>
    );
  }

  return (
    <Popover title={title} content={description} trigger={['click', 'hover']} overlayClassName="tooltip">
      {children}
    </Popover>
  );
}

Tooltip.propTypes = {
  children: PropTypes.node,
  description: PropTypes.node,
  title: PropTypes.node,
};
